// src/modules/app-views/dataSearch/pages/Search/modals/InfoModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const InfoModalStepContent = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Alert
      type="info"
      showIcon
      title={translateX('data_search_info_alert')}
      style={{ marginTop: 8 }}
    />
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
function infoModalStep() {
  return {
    stepTitle: 'how_to_use_data_search',
    stepTooltip: 'data_search_instructions',
    content: () => <InfoModalStepContent />,
    validationFields: [],
    nextButtonText: 'close',
    nextButtonProps: { type: 'default', icon: null },
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default infoModalStep;
